  /**
   * Extracts the unique list of sublists from a list of refernce data items
   * @returns a list of the unique sublist items
   */
  export function getUniqueSublistItems(refDataWithSublists) {
    let uniqueSublistItems = [
      ...new Set(refDataWithSublists.flatMap(item => item.sublist).filter(item => item && item.trim() !== ""))
    ]; 
    return uniqueSublistItems.toSorted();
  }

  /**
   * Check if any entry has no sublist defined
   * @returns true if any item has no sublist defined
   */
  export function hasItemWithNoSublist(refDataWithSublists) {
    let retVal = false;
    refDataWithSublists.forEach(item=>{if (!item.sublist || item.sublist.length===0) {
                                        retVal = true;
                                      }});
    return retVal;
  }

  /**
   * Converts a list of reference data items to a dictionary of the sublists with a list of the relevant items as a list
   * @returns a dictionary of sublist=>[list of refrence data items], with "" used as a key for items that have no sublist
   */
  export function getSublistDictionary(refDataWithSublists, allItemsInEmptySublist=true) {
    let sublistDictionary = {};
    //first sort the list of items
    const sortedList = refDataWithSublists.toSorted((a, b) => (a.description > b.description) ? 1 : -1);
    
    sortedList.forEach(item=>{if (allItemsInEmptySublist===true || !item.sublist || item.sublist.length===0) {
                                createListOrAddItem(sublistDictionary, "", item);
                              };
                              if  (item.sublist) {
                                item.sublist.forEach(sublist=>{
                                  createListOrAddItem(sublistDictionary, sublist, item);
                                })
                              }
                              
                            });
    return sublistDictionary;
  }

  function createListOrAddItem(dictToAddTo, key, value){
    if (key in dictToAddTo) {
      dictToAddTo[key].push(value);
    } else {
      dictToAddTo[key] = [value];
    }
  }

  export function getItemforRefListValue(value, refList) {
    if (refList === undefined) {
      return undefined;
    }
    // find the id for this code
    const reflistItem = refList.find(({ description }) => description === value);
    return reflistItem;
  }

  export function getItemforRefListId(id, refList) {
    // find the id for this code
    const reflistItem = refList.find(({ refListId }) => refListId === id);
    return reflistItem;
  }

  /**
   * Gets a valid sublist entry for this refdata value (or "")
   * @param {*} value The description if the reference list entry
   * @param {*} refList The refrence list
   * @param {*} defaultSublist The value to reuturn if the item is in more than one sublist or cannot be found
   * @returns The sublist if there is only one possibility otherwise the defaultSublist
   */
  export function getSublistforRefListValue(value, refList, defaultSublist="") {
    const reflistItem = getItemforRefListValue(value, refList);
    if (reflistItem) {
      if (!reflistItem.sublist || reflistItem.sublist.length===0) {
        return defaultSublist;
      } else {
        if (reflistItem.sublist.length !== 1) {
          return defaultSublist;
        } else {
          return reflistItem.sublist[0];
        }
      }
    } else {
      return defaultSublist;
    }
  }
